// Constantes y helpers de juegos usados. Los valores internos viajan en inglés
// (coinciden con el backend); la UI se muestra en español.

export const CONDITIONS = [
    { value: 'like_new', label: 'Como nuevo' },
    { value: 'very_good', label: 'Muy bueno' },
    { value: 'good', label: 'Bueno' },
    { value: 'acceptable', label: 'Aceptable' },
];

const CONDITION_LABELS = CONDITIONS.reduce((map, c) => { map[c.value] = c.label; return map; }, {});

const STATE_LABELS = {
    available: 'Disponible',
    sold: 'Vendido',
    withdrawn: 'Retirado',
};

const CREDIT_STATUS_LABELS = {
    pending: 'Pendiente',
    released: 'Liberado',
    cancelled: 'Cancelado',
};

export function conditionLabel(value) {
    return CONDITION_LABELS[value] || value || '-';
}

export function stateLabel(value) {
    return STATE_LABELS[value] || value || '-';
}

export function creditStatusLabel(value) {
    return CREDIT_STATUS_LABELS[value] || value || '-';
}

const CREDIT_REASON_LABELS = {
    used_game_sold: 'Venta de usado',
    purchase_payment: 'Pago de compra',
    adjustment: 'Ajuste manual',
    refund: 'Reversa',
    expiry: 'Vencimiento',
    // Gift cards: el sobrante de una usada o el canje entero, y su reversa al cancelar la compra.
    gift_card: 'Gift card',
    gift_card_reversal: 'Reversa de gift card',
};

export function creditReasonLabel(value) {
    return CREDIT_REASON_LABELS[value] || value || '-';
}
